import React, { useEffect, useState } from 'react';
import axios from 'axios';

import './UserAccount.css';

const API_BASE = 'http://localhost:5001';
const PHONE_CODES = [
  { value: '+27', label: '🇿🇦 Afrique du Sud (+27)' },
  { value: '+213', label: '🇩🇿 Algérie (+213)' },
  { value: '+49', label: '🇩🇪 Allemagne (+49)' },
  { value: '+244', label: '🇦🇴 Angola (+244)' },
  { value: '+43', label: '🇦🇹 Autriche (+43)' },
  { value: '+32', label: '🇧🇪 Belgique (+32)' },
  { value: '+229', label: '🇧🇯 Bénin (+229)' },
  { value: '+267', label: '🇧🇼 Botswana (+267)' },
  { value: '+359', label: '🇧🇬 Bulgarie (+359)' },
  { value: '+226', label: '🇧🇫 Burkina Faso (+226)' },
  { value: '+257', label: '🇧🇮 Burundi (+257)' },
  { value: '+237', label: '🇨🇲 Cameroun (+237)' },
  { value: '+238', label: '🇨🇻 Cap-Vert (+238)' },
  { value: '+236', label: '🇨🇫 Centrafrique (+236)' },
  { value: '+357', label: '🇨🇾 Chypre (+357)' },
  { value: '+269', label: '🇰🇲 Comores (+269)' },
  { value: '+242', label: '🇨🇬 Congo (+242)' },
  { value: '+225', label: "🇨🇮 Côte d'Ivoire (+225)" },
  { value: '+385', label: '🇭🇷 Croatie (+385)' },
  { value: '+45', label: '🇩🇰 Danemark (+45)' },
  { value: '+253', label: '🇩🇯 Djibouti (+253)' },
  { value: '+20', label: '🇪🇬 Égypte (+20)' },
  { value: '+34', label: '🇪🇸 Espagne (+34)' },
  { value: '+372', label: '🇪🇪 Estonie (+372)' },
  { value: '+291', label: '🇪🇷 Érythrée (+291)' },
  { value: '+251', label: '🇪🇹 Éthiopie (+251)' },
  { value: '+358', label: '🇫🇮 Finlande (+358)' },
  { value: '+33', label: '🇫🇷 France (+33)' },
  { value: '+241', label: '🇬🇦 Gabon (+241)' },
  { value: '+220', label: '🇬🇲 Gambie (+220)' },
  { value: '+233', label: '🇬🇭 Ghana (+233)' },
  { value: '+240', label: '🇬🇶 Guinée équatoriale (+240)' },
  { value: '+224', label: '🇬🇳 Guinée (+224)' },
  { value: '+245', label: '🇬🇼 Guinée-Bissau (+245)' },
  { value: '+30', label: '🇬🇷 Grèce (+30)' },
  { value: '+36', label: '🇭🇺 Hongrie (+36)' },
  { value: '+353', label: '🇮🇪 Irlande (+353)' },
  { value: '+354', label: '🇮🇸 Islande (+354)' },
  { value: '+39', label: '🇮🇹 Italie (+39)' },
  { value: '+254', label: '🇰🇪 Kenya (+254)' },
  { value: '+266', label: '🇱🇸 Lesotho (+266)' },
  { value: '+371', label: '🇱🇻 Lettonie (+371)' },
  { value: '+231', label: '🇱🇷 Libéria (+231)' },
  { value: '+218', label: '🇱🇾 Libye (+218)' },
  { value: '+370', label: '🇱🇹 Lituanie (+370)' },
  { value: '+352', label: '🇱🇺 Luxembourg (+352)' },
  { value: '+261', label: '🇲🇬 Madagascar (+261)' },
  { value: '+265', label: '🇲🇼 Malawi (+265)' },
  { value: '+223', label: '🇲🇱 Mali (+223)' },
  { value: '+356', label: '🇲🇹 Malte (+356)' },
  { value: '+212', label: '🇲🇦 Maroc (+212)' },
  { value: '+230', label: '🇲🇺 Maurice (+230)' },
  { value: '+222', label: '🇲🇷 Mauritanie (+222)' },
  { value: '+258', label: '🇲🇿 Mozambique (+258)' },
  { value: '+264', label: '🇳🇦 Namibie (+264)' },
  { value: '+227', label: '🇳🇪 Niger (+227)' },
  { value: '+234', label: '🇳🇬 Nigéria (+234)' },
  { value: '+47', label: '🇳🇴 Norvège (+47)' },
  { value: '+256', label: '🇺🇬 Ouganda (+256)' },
  { value: '+31', label: '🇳🇱 Pays-Bas (+31)' },
  { value: '+48', label: '🇵🇱 Pologne (+48)' },
  { value: '+351', label: '🇵🇹 Portugal (+351)' },
  { value: '+243', label: '🇨🇩 République démocratique du Congo (+243)' },
  { value: '+40', label: '🇷🇴 Roumanie (+40)' },
  { value: '+44', label: '🇬🇧 Royaume-Uni (+44)' },
  { value: '+250', label: '🇷🇼 Rwanda (+250)' },
  { value: '+239', label: '🇸🇹 São Tomé-et-Principe (+239)' },
  { value: '+221', label: '🇸🇳 Sénégal (+221)' },
  { value: '+248', label: '🇸🇨 Seychelles (+248)' },
  { value: '+232', label: '🇸🇱 Sierra Leone (+232)' },
  { value: '+421', label: '🇸🇰 Slovaquie (+421)' },
  { value: '+386', label: '🇸🇮 Slovénie (+386)' },
  { value: '+252', label: '🇸🇴 Somalie (+252)' },
  { value: '+249', label: '🇸🇩 Soudan (+249)' },
  { value: '+211', label: '🇸🇸 Soudan du Sud (+211)' },
  { value: '+46', label: '🇸🇪 Suède (+46)' },
  { value: '+41', label: '🇨🇭 Suisse (+41)' },
  { value: '+255', label: '🇹🇿 Tanzanie (+255)' },
  { value: '+235', label: '🇹🇩 Tchad (+235)' },
  { value: '+420', label: '🇨🇿 Tchéquie (+420)' },
  { value: '+228', label: '🇹🇬 Togo (+228)' },
  { value: '+216', label: '🇹🇳 Tunisie (+216)' },
  { value: '+90', label: '🇹🇷 Turquie (+90)' },
  { value: '+260', label: '🇿🇲 Zambie (+260)' },
  { value: '+263', label: '🇿🇼 Zimbabwe (+263)' }
];

function UserAccount() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [passwordMessage, setPasswordMessage] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [passwordSubmitting, setPasswordSubmitting] = useState(false);
  const [phoneModalOpen, setPhoneModalOpen] = useState(false);
  const [phoneForm, setPhoneForm] = useState({
    phoneCountryCode: '',
    phoneNumber: ''
  });
  const [phoneMessage, setPhoneMessage] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [phoneSubmitting, setPhoneSubmitting] = useState(false);
  const [addressModalOpen, setAddressModalOpen] = useState(false);
  const [addressForm, setAddressForm] = useState({
    city: '',
    postalCode: '',
    streetAddress: ''
  });
  const [addressMessage, setAddressMessage] = useState('');
  const [addressError, setAddressError] = useState('');
  const [addressSubmitting, setAddressSubmitting] = useState(false);
  const [orders, setOrders] = useState([]);
  const [ordersLoading, setOrdersLoading] = useState(true);
  const [ordersError, setOrdersError] = useState('');

  const [passwordVisibility, setPasswordVisibility] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false
  });

  const formatDate = (value) => {
    if (!value) return 'Date inconnue';
    try {
      return new Date(value).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' });
    } catch (err) {
      return value;
    }
  };

  const formatCurrency = (amount) => {
    const numeric = Number(amount || 0);
    return `${numeric.toFixed(2)} €`;
  };

  const computeItemsCount = (products = []) => products.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setOrdersLoading(true);
      setError('');
      setOrdersError('');
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setError('Veuillez vous connecter pour accéder à votre compte.');
          setOrdersError('Veuillez vous connecter pour voir vos commandes.');
          setLoading(false);
          setOrdersLoading(false);
          return;
        }
        const headers = { Authorization: `Bearer ${token}` };
        const [profileRes, ordersRes] = await Promise.all([
          axios.get(`${API_BASE}/api/users/me`, { headers }),
          axios.get(`${API_BASE}/api/orders`, { headers })
        ]);
        setProfile(profileRes.data);
        const orderedList = Array.isArray(ordersRes.data) ? [...ordersRes.data] : [];
        orderedList.sort((a, b) => new Date(b.createdAt || b.updatedAt || 0) - new Date(a.createdAt || a.updatedAt || 0));
        setOrders(orderedList);
      } catch (err) {
        const message = err.response?.data?.error || 'Erreur lors de la récupération du profil.';
        setError(message);
        setOrdersError(err.response?.data?.error || 'Erreur lors de la récupération des commandes.');
      } finally {
        setLoading(false);
        setOrdersLoading(false);
      }
    };

    fetchData();
  }, []);

  const patchProfile = async (payload) => {
    const token = localStorage.getItem('token');
    const res = await axios.patch(`${API_BASE}/api/users/me`, payload, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setProfile(res.data);
    return res.data;
  };

  const openPasswordModal = () => {
    setPasswordMessage('');
    setPasswordError('');
    setPasswordForm({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    });
    setPasswordModalOpen(true);
  };

  const closePasswordModal = () => {
    setPasswordModalOpen(false);
  };

  const handlePasswordChange = (event) => {
    const { name, value } = event.target;
    setPasswordForm((prev) => ({
      ...prev,
      [name]: value
    }));
    setPasswordError('');
  };

  const toggleVisibility = (field) => {
    setPasswordVisibility((prev) => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  const handlePasswordSubmit = async (event) => {
    event.preventDefault();
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      setPasswordError('Le mot de passe confirmé ne correspond pas.');
      return;
    }
    setPasswordSubmitting(true);
    setPasswordMessage('');
    setPasswordError('');
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API_BASE}/api/users/change-password`, {
        currentPassword: passwordForm.currentPassword,
        newPassword: passwordForm.newPassword
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPasswordMessage('Mot de passe modifié avec succès.');
      setPasswordForm({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      });
      setPasswordSubmitting(false);
      setTimeout(() => {
        closePasswordModal();
        setPasswordMessage('');
      }, 1500);
    } catch (err) {
      setPasswordSubmitting(false);
      setPasswordError(err.response?.data?.error || 'Impossible de modifier le mot de passe.');
    }
  };

  const openPhoneModal = () => {
    if (!profile) return;
    setPhoneForm({
      phoneCountryCode: profile.phoneCountryCode || '+33',
      phoneNumber: profile.phoneNumber || ''
    });
    setPhoneMessage('');
    setPhoneError('');
    setPhoneModalOpen(true);
  };

  const closePhoneModal = () => {
    setPhoneModalOpen(false);
  };

  const handlePhoneChange = (event) => {
    const { name, value } = event.target;
    setPhoneForm((prev) => ({
      ...prev,
      [name]: value
    }));
    setPhoneError('');
  };

  const handlePhoneSubmit = async (event) => {
    event.preventDefault();
    setPhoneSubmitting(true);
    setPhoneMessage('');
    setPhoneError('');
    try {
      await patchProfile({
        phoneCountryCode: phoneForm.phoneCountryCode,
        phoneNumber: phoneForm.phoneNumber
      });
      setPhoneMessage('Numéro mis à jour.');
      setPhoneSubmitting(false);
      setTimeout(() => {
        setPhoneModalOpen(false);
        setPhoneMessage('');
      }, 1200);
    } catch (err) {
      setPhoneSubmitting(false);
      setPhoneError(err.response?.data?.error || 'Impossible de mettre à jour le numéro.');
    }
  };

  const openAddressModal = () => {
    if (!profile) return;
    setAddressForm({
      city: profile.city || '',
      postalCode: profile.postalCode || '',
      streetAddress: profile.address || ''
    });
    setAddressMessage('');
    setAddressError('');
    setAddressModalOpen(true);
  };

  const closeAddressModal = () => {
    setAddressModalOpen(false);
  };

  const handleAddressChange = (event) => {
    const { name, value } = event.target;
    setAddressForm((prev) => ({
      ...prev,
      [name]: value
    }));
    setAddressError('');
  };

  const handleAddressSubmit = async (event) => {
    event.preventDefault();
    if (!addressForm.city.trim() || !addressForm.postalCode.trim() || !addressForm.streetAddress.trim()) {
      setAddressError('Tous les champs sont obligatoires.');
      return;
    }
    setAddressSubmitting(true);
    setAddressMessage('');
    setAddressError('');
    try {
      await patchProfile({
        city: addressForm.city.trim(),
        postalCode: addressForm.postalCode.trim(),
        streetAddress: addressForm.streetAddress.trim()
      });
      setAddressMessage('Adresse mise à jour.');
      setAddressSubmitting(false);
      setTimeout(() => {
        setAddressModalOpen(false);
        setAddressMessage('');
      }, 1200);
    } catch (err) {
      setAddressSubmitting(false);
      setAddressError(err.response?.data?.error || 'Impossible de mettre à jour l’adresse.');
    }
  };

  return (
    <div className="account-page">
      <div className="account-card">
        <h2 className="account-title">Mon compte</h2>
        {loading ? (
          <p>Chargement...</p>
        ) : error ? (
          <p className="account-message account-message--error">{error}</p>
        ) : profile ? (
          <>
            <div className="account-grid">
              <div className="account-field">
                <span className="account-field__label">Nom de l'entreprise</span>
                <span className="account-field__value">{profile.companyName || '—'}</span>
              </div>
              <div className="account-field">
                <span className="account-field__label">KBIS</span>
                <span className="account-field__value">{profile.kbis || '—'}</span>
              </div>
              <div className="account-field">
                <span className="account-field__label">Adresse email</span>
                <span className="account-field__value">{profile.email || '—'}</span>
              </div>
              <div
                className="account-field account-field--clickable"
                role="button"
                tabIndex={0}
                onClick={openPhoneModal}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    openPhoneModal();
                  }
                }}
              >
                <span className="account-field__label">Téléphone</span>
                <span className="account-field__value">
                  {profile.phoneCountryCode || profile.phoneNumber ? `${profile.phoneCountryCode || ''} ${profile.phoneNumber || ''}`.trim() || '—' : '—'}
                </span>
              </div>
              <div className="account-field">
                <span className="account-field__label">Ville</span>
                <span className="account-field__value">{profile.city || '—'}</span>
              </div>
              <div
                className="account-field account-field--wide account-field--clickable"
                role="button"
                tabIndex={0}
                onClick={openAddressModal}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    openAddressModal();
                  }
                }}
              >
                <span className="account-field__label">Adresse postale</span>
                <span className="account-field__value">
                  {[profile.address, profile.postalCode, profile.city].filter(Boolean).join(' , ') || '—'}
                </span>
              </div>
            </div>
            <div className="account-actions">
              <button type="button" className="account-button" onClick={openPasswordModal}>
                Modifier le mot de passe
              </button>
            </div>
            <section className="account-orders">
              <h3>Historique des commandes</h3>
              {ordersLoading ? (
                <p>Chargement de vos commandes...</p>
              ) : ordersError ? (
                <p className="account-message account-message--error">{ordersError}</p>
              ) : orders.length === 0 ? (
                <p className="account-message">Vous n'avez pas encore passé de commande.</p>
              ) : (
                <div className="account-orders__list">
                  {orders.map((order) => {
                    const orderDate = formatDate(order.createdAt || order.updatedAt);
                    const itemsCount = computeItemsCount(order.products);
                    const totalAmount = formatCurrency(order.total);
                    return (
                      <article key={order._id} className="account-order-card">
                        <header className="account-order-card__header">
                          <div>
                            <span className="account-order-card__id">Commande #{order._id?.slice(-8)}</span>
                            <span className="account-order-card__date">{orderDate}</span>
                          </div>
                          <span className={`account-order-card__status account-order-card__status--${order.status || 'pending'}`}>
                            {order.status || 'pending'}
                          </span>
                        </header>
                        <div className="account-order-card__meta">
                          <span>{itemsCount} article(s)</span>
                          <span>Total : {totalAmount}</span>
                        </div>
                        {order.products?.length ? (
                          <ul className="account-order-card__products">
                            {order.products.map((item, idx) => {
                              const name = item.product?.name || 'Produit';
                              const quantity = item.quantity || 0;
                              const unitPrice = item.product?.price;
                              return (
                                <li key={`${order._id}-product-${idx}`}>
                                  <span className="account-order-card__product-name">{name}</span>
                                  <span className="account-order-card__product-qty">x{quantity}</span>
                                  {unitPrice ? (
                                    <span className="account-order-card__product-price">{formatCurrency(unitPrice)}</span>
                                  ) : null}
                                </li>
                              );
                            })}
                          </ul>
                        ) : (
                          <p className="account-order-card__empty">Cette commande ne contient aucun article.</p>
                        )}
                      </article>
                    );
                  })}
                </div>
              )}
            </section>
          </>
        ) : (
          <p className="account-message">Aucune information de compte disponible.</p>
        )}
      </div>

      {passwordModalOpen && (
        <div className="account-password-modal" role="dialog" aria-modal="true">
          <div className="account-password-modal__content">
            <header className="account-password-modal__header">
              <h3>Modifier le mot de passe</h3>
              <button type="button" className="account-password-modal__close" onClick={closePasswordModal} aria-label="Fermer la fenêtre de changement de mot de passe">
                ×
              </button>
            </header>
            <form className="account-password-form" onSubmit={handlePasswordSubmit}>
              <label className="account-password-form__field">
                <span>Mot de passe actuel</span>
                <div className="account-password-form__input-wrapper">
                  <input
                    type={passwordVisibility.currentPassword ? 'text' : 'password'}
                    name="currentPassword"
                    value={passwordForm.currentPassword}
                    onChange={handlePasswordChange}
                    required
                  />
                  <button
                    type="button"
                    className="account-password-form__toggle"
                    aria-label={passwordVisibility.currentPassword ? 'Masquer le mot de passe actuel' : 'Afficher le mot de passe actuel'}
                    onClick={() => toggleVisibility('currentPassword')}
                  >
                    {passwordVisibility.currentPassword ? '🙈' : '👁️'}
                  </button>
                </div>
              </label>
              <label className="account-password-form__field">
                <span>Nouveau mot de passe</span>
                <div className="account-password-form__input-wrapper">
                  <input
                    type={passwordVisibility.newPassword ? 'text' : 'password'}
                    name="newPassword"
                    value={passwordForm.newPassword}
                    onChange={handlePasswordChange}
                    required
                  />
                  <button
                    type="button"
                    className="account-password-form__toggle"
                    aria-label={passwordVisibility.newPassword ? 'Masquer le nouveau mot de passe' : 'Afficher le nouveau mot de passe'}
                    onClick={() => toggleVisibility('newPassword')}
                  >
                    {passwordVisibility.newPassword ? '🙈' : '👁️'}
                  </button>
                </div>
              </label>
              <label className="account-password-form__field">
                <span>Confirmer le nouveau mot de passe</span>
                <div className="account-password-form__input-wrapper">
                  <input
                    type={passwordVisibility.confirmPassword ? 'text' : 'password'}
                    name="confirmPassword"
                    value={passwordForm.confirmPassword}
                    onChange={handlePasswordChange}
                    required
                  />
                  <button
                    type="button"
                    className="account-password-form__toggle"
                    aria-label={passwordVisibility.confirmPassword ? 'Masquer la confirmation du mot de passe' : 'Afficher la confirmation du mot de passe'}
                    onClick={() => toggleVisibility('confirmPassword')}
                  >
                    {passwordVisibility.confirmPassword ? '🙈' : '👁️'}
                  </button>
                </div>
              </label>
              {passwordError && <p className="account-message account-message--error">{passwordError}</p>}
              {passwordMessage && <p className="account-message account-message--success">{passwordMessage}</p>}
              <div className="account-password-form__actions">
                <button type="button" className="account-button account-button--ghost" onClick={closePasswordModal}>
                  Annuler
                </button>
                <button type="submit" className="account-button" disabled={passwordSubmitting}>
                  {passwordSubmitting ? 'Validation...' : 'Valider'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {phoneModalOpen && (
        <div className="account-password-modal" role="dialog" aria-modal="true">
          <div className="account-password-modal__content">
            <header className="account-password-modal__header">
              <h3>Modifier le numéro de téléphone</h3>
              <button type="button" className="account-password-modal__close" onClick={closePhoneModal} aria-label="Fermer la fenêtre de modification du téléphone">
                ×
              </button>
            </header>
            <form className="account-password-form" onSubmit={handlePhoneSubmit}>
              <label className="account-password-form__field">
                <span>Indicatif téléphonique du pays</span>
                <select
                  name="phoneCountryCode"
                  value={phoneForm.phoneCountryCode}
                  onChange={handlePhoneChange}
                  required
                >
                  <option value="">Sélectionnez un indicatif</option>
                  {PHONE_CODES.map((code) => (
                    <option key={code.value} value={code.value}>
                      {code.label}
                    </option>
                  ))}
                </select>
              </label>
              <label className="account-password-form__field">
                <span>Numéro de téléphone</span>
                <input
                  type="number"
                  name="phoneNumber"
                  value={phoneForm.phoneNumber}
                  onChange={handlePhoneChange}
                  required
                />
              </label>
              {phoneError && <p className="account-message account-message--error">{phoneError}</p>}
              {phoneMessage && <p className="account-message account-message--success">{phoneMessage}</p>}
              <div className="account-password-form__actions">
                <button type="button" className="account-button account-button--ghost" onClick={closePhoneModal}>
                  Annuler
                </button>
                <button type="submit" className="account-button" disabled={phoneSubmitting}>
                  {phoneSubmitting ? 'Validation...' : 'Valider'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {addressModalOpen && (
        <div className="account-password-modal" role="dialog" aria-modal="true">
          <div className="account-password-modal__content">
            <header className="account-password-modal__header">
              <h3>Modifier l'adresse postale</h3>
              <button type="button" className="account-password-modal__close" onClick={closeAddressModal} aria-label="Fermer la fenêtre de modification de l'adresse">
                ×
              </button>
            </header>
            <form className="account-password-form" onSubmit={handleAddressSubmit}>
              <label className="account-password-form__field">
                <span>Ville</span>
                <input
                  type="text"
                  name="city"
                  value={addressForm.city}
                  onChange={handleAddressChange}
                  required
                />
              </label>
              <label className="account-password-form__field">
                <span>Code postal</span>
                <input
                  type="text"
                  name="postalCode"
                  value={addressForm.postalCode}
                  onChange={handleAddressChange}
                  required
                />
              </label>
              <label className="account-password-form__field">
                <span>Numéro et voie</span>
                <textarea
                  rows="2"
                  name="streetAddress"
                  value={addressForm.streetAddress}
                  onChange={handleAddressChange}
                  required
                />
              </label>
              {addressError && <p className="account-message account-message--error">{addressError}</p>}
              {addressMessage && <p className="account-message account-message--success">{addressMessage}</p>}
              <div className="account-password-form__actions">
                <button type="button" className="account-button account-button--ghost" onClick={closeAddressModal}>
                  Annuler
                </button>
                <button type="submit" className="account-button" disabled={addressSubmitting}>
                  {addressSubmitting ? 'Validation...' : 'Valider'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserAccount;
